import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {
  blog: any[] = [];
  blogArray: any [] = []
  constructor(    private service: ApiServicesService,
    private router: Router
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);  
    this.BlogsAPIData();
  }
    BlogsAPIData() {
      this.service.post({},API_ROUTES.blogsData.blogsDataList, {})
        .subscribe((res) => {
          if (res.success) {
            this.blogArray = res.data;
          } else {
            console.error('Failed to fetch Terms of Use', res.message);
          }
        }
        );
    }
  
  navigateToBlogDetail(alias: string): void {
    this.router.navigate([`/blogs/${alias}`]);
  }

  formatDate(date: string): string {
    const parsedDate = new Date(date);
    return parsedDate.toISOString().split('T')[0]; 
  }
}
